import "./BannerImageSection.css"

const BannerImageSection = () => {
    return (
        <div className="banner-image-section">
            <div className="banner-slogan-wrapper">
                <div className="banner-slogan-container">
                    <div className="banner-slogan">
                        Consistent & Persistent
                    </div>
                </div>
            </div>
            <div className="banner-image" />
        </div>
    );
}
export default BannerImageSection;